
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as statsnxDSwzPP0vfKmg9FCtYvCZ3Gh8ndPEONmdYiFbRvs2kMeta } from "/app/pages/stats.vue?macro=true";
import { default as _91slug_930GqRg_45URxZnrbZhQR1HdrptjGhpkIM9RWyzbD3F8irkMeta } from "/app/pages/[slug].vue?macro=true";
import { default as searchWiCwPORWRkcZm1zH29UWKNMF4Vb5hM_q5Mi2yI40hlcMeta } from "/app/pages/search.vue?macro=true";
import { default as schedulejf7sR_m72cwNHLv9OlMc_455G2wJ0SUSovCtrz464sIGUMeta } from "/app/pages/schedule.vue?macro=true";
import { default as standingsn4cFXYpW76__SEPppOIz2YLtNNdDyTd5vrBNfJ0Ts_45UMeta } from "/app/pages/standings.vue?macro=true";
import { default as indexkpkhE2Zx_45wVJqyj11FyNpnGQQa93xlI5j2_nUvO6G4wMeta } from "/app/pages/news/index.vue?macro=true";
import { default as _91slug_93OY1eKGH50IeGHXpXb3BdZRgtgqHXLtURcDbb48n4NVYMeta } from "/app/pages/news/[slug].vue?macro=true";
import { default as indexPchdRjEbhiMh06CLZYXTGZYvGbmyr7gxd0xNluJhg0IMeta } from "/app/pages/scores/index.vue?macro=true";
import { default as newsNOTzeB275mwxnJHp2bZ5bTlZmoqt77YXGWvBTFB2auYMeta } from "/app/pages/teams/[slug]/news.vue?macro=true";
import { default as index2Ae5x57D8cMrx2xLHdM_45VWJut0af8FB18HVYOnTMIHoMeta } from "/app/pages/teams/[slug]/index.vue?macro=true";
import { default as index4Epjm_KSNJfJBqVNSAyo7VbFMK8fKCYH27Bb0t2rb_45gMeta } from "/app/pages/teams/[slug]/stats/index.vue?macro=true";
import { default as resultsj245DA6ps8z9ZXFZGtJixsT4_dkrWWkue1WuP7crDK0Meta } from "/app/pages/teams/[slug]/stats/results.vue?macro=true";
import { default as individual_O0jwT2yWsZ0nDWI0puWUXCKpYULvjYjqpLrpS88dsoMeta } from "/app/pages/teams/[slug]/stats/individual.vue?macro=true";
import { default as statsTZSK6GD9LJaDS_KqVDLZah0MX3MNNyl526Gh8FnnYOMMeta } from "/app/pages/teams/[slug]/stats.vue?macro=true";
import { default as rosteryAycEo6ZcURc3pyjNkVnQp6Kooyy7Zwf1N1b_egy_VoMeta } from "/app/pages/teams/[slug]/roster.vue?macro=true";
import { default as videosulv68eCxnK0TpTTwyh3eEgPFI_45lIVP7oVuNlLX1wzr0Meta } from "/app/pages/teams/[slug]/videos.vue?macro=true";
import { default as coaches_451LqKaRK8JZiefHt2v_45DVszTiAR2y3F_SCwa7OQXD9UMeta } from "/app/pages/teams/[slug]/coaches.vue?macro=true";
import { default as galleryzOqh2VQwv5V_45e6velT1DQ47ZAd6SoZMRSzQwhk8_4KMMeta } from "/app/pages/teams/[slug]/gallery.vue?macro=true";
import { default as indexAlb93HTqFU_VjXjfGrCsblSpgKNIXEqIm7FBXS9dxGoMeta } from "/app/pages/teams/[slug]/[player]/index.vue?macro=true";
import { default as statssAIzr8aPfG6SgiUTVVlddxU2nvbmG_4569kOTj0AjFn2EMeta } from "/app/pages/teams/[slug]/[player]/stats.vue?macro=true";
import { default as videomL3_45nMPbrjZMc6ITLPRCRlnh_4A19BPvjtNpHtZIqmIMeta } from "/app/pages/teams/[slug]/[player]/video.vue?macro=true";
import { default as transactionspBFwjhK9_4_45vsH_kFXNeLT3QKXGW4qnV_45n7fmuHZkmIMeta } from "/app/pages/teams/[slug]/[player]/transactions.vue?macro=true";
import { default as _91player_93eRxY4MYIR0KuctcJxFjGyflZJ_45rcFSVjhDKInZqJ2IoMeta } from "/app/pages/teams/[slug]/[player].vue?macro=true";
import { default as scheduleTG_45YcDMlNesXzuEGksnL5JatnqNd00JofQfqrPx6eMgMeta } from "/app/pages/teams/[slug]/schedule.vue?macro=true";
import { default as _91slug_93HwVlaJK_XGxvh5fOISqkaycAhjAKHA7tEDABLbUThjoMeta } from "/app/pages/teams/[slug].vue?macro=true";
import { default as transactionsUH9VgiSoM7RBJyL7wGtWtRC64eyMsQgF3Ap2aduDZhkMeta } from "/app/pages/transactions.vue?macro=true";
import { default as indexdMRwWiIeooMPsr5v7feD72q5mpjJrTYTplUmAo1CixoMeta } from "/app/pages/videos/index.vue?macro=true";
import { default as indexQK9GlDDj2Ph8FWRi2aM5_45pfl1hYDi_oAxWcJkRkUo_45YMeta } from "/app/pages/gallery/index.vue?macro=true";
import { default as _91slug_93a_jsftxD6bjKDrvceHAan4IXpYP2hyAWCxXoqfnul5MMeta } from "/app/pages/videos/[slug].vue?macro=true";
import { default as _91slug_93gWIK4t3zRqA5lvEX7x_45LSsOhwvPEQRODbFlT8wj0ZToMeta } from "/app/pages/gallery/[slug].vue?macro=true";
import { default as dev_45error_45triggerEczGaFtQT4np71wlhm3GffLP_iMEkWykdsndy1v1t9wMeta } from "/app/pages/dev-error-trigger.vue?macro=true";
import { default as add_45to_45calendar53JOf06EdfTHhO3dYOl9uDQsArvQsaWEPgVV650ko8AMeta } from "/app/pages/teams/add-to-calendar.vue?macro=true";
import { default as indexsDB0douzj9sODnWXTmLJVDL23SUzTqsvXjba8SyYLyoMeta } from "/app/pages/scores/[scheduleEventId]/index.vue?macro=true";
import { default as playsGt7CpAL8OXlOfJPaRH6xCWmlTi92A1HCgeMjOaygY_cMeta } from "/app/pages/scores/[scheduleEventId]/plays.vue?macro=true";
import { default as drivesJsTaOYltbtjXMknLfSGjAwoum4JCH7BsFw9_45FyBiUTcMeta } from "/app/pages/scores/[scheduleEventId]/drives.vue?macro=true";
import { default as defenseo9YZk5vC7MEgsJnyuGosqQt1K45bkpjBYS4ZBnL3Ec4Meta } from "/app/pages/scores/[scheduleEventId]/defense.vue?macro=true";
import { default as offensebyQapMtsumUT0oBpYfm_bzc0LV80lEZYKkHGYDXxDk0Meta } from "/app/pages/scores/[scheduleEventId]/offense.vue?macro=true";
import { default as special_45teamsaharss5gwpj5GzSeW_LzHwLY6LhO1l1NOMHUoxY5ZiQMeta } from "/app/pages/scores/[scheduleEventId]/special-teams.vue?macro=true";
import { default as _91scheduleEventId_93oErqn_YFCbgyGPWup2u7qorzbmHb79nmtN2UL0VD_uAMeta } from "/app/pages/scores/[scheduleEventId].vue?macro=true";
import { default as indexjuGk0EaU9FEbqD_458hXw3ArhphIinA4h0WH6DNzNLhc4Meta } from "/app/pages/preview/[article]/[version]/index.vue?macro=true";
import { default as _91version_934Va1tucrEUCPPt3iHCrv3niR0cqrzoZnupoQhrBouzsMeta } from "/app/pages/preview/[article]/[version].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "stats",
    path: "/stats",
    component: () => import("/app/pages/stats.vue")
  },
  {
    name: "slug",
    path: "/:slug()",
    meta: { ...(_91slug_930GqRg_45URxZnrbZhQR1HdrptjGhpkIM9RWyzbD3F8irkMeta || {}), ...{"layout":false} },
    component: () => import("/app/pages/[slug].vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/app/pages/search.vue")
  },
  {
    name: "schedule",
    path: "/schedule",
    component: () => import("/app/pages/schedule.vue")
  },
  {
    name: "standings",
    path: "/standings",
    component: () => import("/app/pages/standings.vue")
  },
  {
    name: "news",
    path: "/news",
    component: () => import("/app/pages/news/index.vue")
  },
  {
    name: "news-slug",
    path: "/news/:slug()",
    meta: { ...(_91slug_93OY1eKGH50IeGHXpXb3BdZRgtgqHXLtURcDbb48n4NVYMeta || {}), ...{"layout":false} },
    component: () => import("/app/pages/news/[slug].vue")
  },
  {
    name: "scores",
    path: "/scores",
    component: () => import("/app/pages/scores/index.vue")
  },
  {
    name: _91slug_93HwVlaJK_XGxvh5fOISqkaycAhjAKHA7tEDABLbUThjoMeta?.name,
    path: "/teams/:slug()",
    meta: { ...(_91slug_93HwVlaJK_XGxvh5fOISqkaycAhjAKHA7tEDABLbUThjoMeta || {}), ...{"layout":false} },
    component: () => import("/app/pages/teams/[slug].vue"),
    children: [
  {
    name: "teams-slug-news",
    path: "news",
    component: () => import("/app/pages/teams/[slug]/news.vue")
  },
  {
    name: "teams-slug",
    path: "",
    component: () => import("/app/pages/teams/[slug]/index.vue")
  },
  {
    name: statsTZSK6GD9LJaDS_KqVDLZah0MX3MNNyl526Gh8FnnYOMMeta?.name,
    path: "stats",
    meta: { ...(statsTZSK6GD9LJaDS_KqVDLZah0MX3MNNyl526Gh8FnnYOMMeta || {}), ...{"layout":false} },
    component: () => import("/app/pages/teams/[slug]/stats.vue"),
    children: [
  {
    name: "teams-slug-stats",
    path: "",
    component: () => import("/app/pages/teams/[slug]/stats/index.vue")
  },
  {
    name: "teams-slug-stats-results",
    path: "results",
    component: () => import("/app/pages/teams/[slug]/stats/results.vue")
  },
  {
    name: "teams-slug-stats-individual",
    path: "individual",
    component: () => import("/app/pages/teams/[slug]/stats/individual.vue")
  }
]
  },
  {
    name: "teams-slug-roster",
    path: "roster",
    component: () => import("/app/pages/teams/[slug]/roster.vue")
  },
  {
    name: "teams-slug-videos",
    path: "videos",
    component: () => import("/app/pages/teams/[slug]/videos.vue")
  },
  {
    name: "teams-slug-coaches",
    path: "coaches",
    component: () => import("/app/pages/teams/[slug]/coaches.vue")
  },
  {
    name: "teams-slug-gallery",
    path: "gallery",
    component: () => import("/app/pages/teams/[slug]/gallery.vue")
  },
  {
    name: _91player_93eRxY4MYIR0KuctcJxFjGyflZJ_45rcFSVjhDKInZqJ2IoMeta?.name,
    path: ":player()",
    meta: { ...(_91player_93eRxY4MYIR0KuctcJxFjGyflZJ_45rcFSVjhDKInZqJ2IoMeta || {}), ...{"layout":false} },
    component: () => import("/app/pages/teams/[slug]/[player].vue"),
    children: [
  {
    name: "teams-slug-player",
    path: "",
    component: () => import("/app/pages/teams/[slug]/[player]/index.vue")
  },
  {
    name: "teams-slug-player-stats",
    path: "stats",
    component: () => import("/app/pages/teams/[slug]/[player]/stats.vue")
  },
  {
    name: "teams-slug-player-video",
    path: "video",
    component: () => import("/app/pages/teams/[slug]/[player]/video.vue")
  },
  {
    name: "teams-slug-player-transactions",
    path: "transactions",
    component: () => import("/app/pages/teams/[slug]/[player]/transactions.vue")
  }
]
  },
  {
    name: "teams-slug-schedule",
    path: "schedule",
    component: () => import("/app/pages/teams/[slug]/schedule.vue")
  }
]
  },
  {
    name: "transactions",
    path: "/transactions",
    component: () => import("/app/pages/transactions.vue")
  },
  {
    name: "videos",
    path: "/videos",
    component: () => import("/app/pages/videos/index.vue")
  },
  {
    name: "gallery",
    path: "/gallery",
    component: () => import("/app/pages/gallery/index.vue")
  },
  {
    name: "videos-slug",
    path: "/videos/:slug()",
    meta: { ...(_91slug_93a_jsftxD6bjKDrvceHAan4IXpYP2hyAWCxXoqfnul5MMeta || {}), ...{"layout":false} },
    component: () => import("/app/pages/videos/[slug].vue")
  },
  {
    name: "gallery-slug",
    path: "/gallery/:slug()",
    meta: { ...(_91slug_93gWIK4t3zRqA5lvEX7x_45LSsOhwvPEQRODbFlT8wj0ZToMeta || {}), ...{"layout":false} },
    component: () => import("/app/pages/gallery/[slug].vue")
  },
  {
    name: "dev-error-trigger",
    path: "/dev-error-trigger",
    component: () => import("/app/pages/dev-error-trigger.vue")
  },
  {
    name: "teams-add-to-calendar",
    path: "/teams/add-to-calendar",
    meta: { ...(add_45to_45calendar53JOf06EdfTHhO3dYOl9uDQsArvQsaWEPgVV650ko8AMeta || {}), ...{"layout":false} },
    component: () => import("/app/pages/teams/add-to-calendar.vue")
  },
  {
    name: _91scheduleEventId_93oErqn_YFCbgyGPWup2u7qorzbmHb79nmtN2UL0VD_uAMeta?.name,
    path: "/scores/:scheduleEventId()",
    meta: { ...(_91scheduleEventId_93oErqn_YFCbgyGPWup2u7qorzbmHb79nmtN2UL0VD_uAMeta || {}), ...{"ignoreScroll":true} },
    component: () => import("/app/pages/scores/[scheduleEventId].vue"),
    children: [
  {
    name: "scores-scheduleEventId",
    path: "",
    component: () => import("/app/pages/scores/[scheduleEventId]/index.vue")
  },
  {
    name: "scores-scheduleEventId-plays",
    path: "plays",
    component: () => import("/app/pages/scores/[scheduleEventId]/plays.vue")
  },
  {
    name: "scores-scheduleEventId-drives",
    path: "drives",
    component: () => import("/app/pages/scores/[scheduleEventId]/drives.vue")
  },
  {
    name: "scores-scheduleEventId-defense",
    path: "defense",
    component: () => import("/app/pages/scores/[scheduleEventId]/defense.vue")
  },
  {
    name: "scores-scheduleEventId-offense",
    path: "offense",
    component: () => import("/app/pages/scores/[scheduleEventId]/offense.vue")
  },
  {
    name: "scores-scheduleEventId-special-teams",
    path: "special-teams",
    component: () => import("/app/pages/scores/[scheduleEventId]/special-teams.vue")
  }
]
  },
  {
    name: _91version_934Va1tucrEUCPPt3iHCrv3niR0cqrzoZnupoQhrBouzsMeta?.name,
    path: "/preview/:article()/:version()",
    component: () => import("/app/pages/preview/[article]/[version].vue"),
    children: [
  {
    name: "preview-article-version",
    path: "",
    meta: { ...(indexjuGk0EaU9FEbqD_458hXw3ArhphIinA4h0WH6DNzNLhc4Meta || {}), ...{"layout":false} },
    component: () => import("/app/pages/preview/[article]/[version]/index.vue")
  }
]
  }
]